export default __webpack_public_path__ + "static/media/course3_W.60008450.jpg";